export const ACTION_TYPE = Object.freeze({
  CLEAR_STORE: "CLEAR_STORE",
});

export const CLEAR_STORE = (payload) => ({
  type: ACTION_TYPE.CLEAR_STORE,
  payload
});
